import { connect } from 'react-redux';
import HeaderTop from './HeaderTop';


const mapStateToProps = state => ({
});


export default connect(mapStateToProps)(HeaderTop);
